import type { HTMLAttributes } from 'react';

type Tag = 'p' | 'span' | 'div';

interface RevealProps extends HTMLAttributes<HTMLElement> {
  as?: Tag;
}

/** Element that fades and rises in when its section timeline reaches it. */
export function Reveal({ as = 'div', children, ...rest }: RevealProps) {
  const Component = as;
  return (
    <Component data-reveal {...rest}>
      {children}
    </Component>
  );
}
